import React from "react";
import forxiga from "../assets/forxiga-logo.png";
import xigduo from "../assets/xigduo-logo.png";
import astrazeneca from "../assets/astrazeneca_logo.png";
function Nav() {
  return (
    <nav>
      <div className="left-logo">
        <img src={astrazeneca} alt={`astrazeneca logo`} />
      </div>
      <div>
        <img src={forxiga} alt={`forxiga logo`} />
      </div>
      <div>
        <img src={xigduo} alt={`xigduo logo`} />
      </div>
    </nav>
  );
}

export default Nav;
